export const BaseDict = {
    FirstHalf: "H1",
    SecondHalf: "H2",
    BreakAfterFirstHalf: "HT",
    Overtime: "OT"
};
//# sourceMappingURL=dict.js.map